module.exports = __webpack_public_path__ + "img/Fargflackgul.7ef3bd65.png";